import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-transit',
    templateUrl: './transit.component.html',
    styleUrls: ['./transit.component.css']
})
export class TransitComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmited = false;
    private defaultMileValue = 0;
    private defaultIntervalValue = 'week';

    public transitForm: FormGroup;
    public periodsList = [
        {key: 'week', value: 'per Week'},
        {key: 'month', value: 'per Month'},
        {key: 'year', value: 'per Year'}
    ];

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.transitForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    private createForm() {
        this.transitForm = this.fb.group({
            trainMile: [this.defaultMileValue, this.getNumbersValidatorsArray()],
            busMile: [this.defaultMileValue, this.getNumbersValidatorsArray()],
            taxiMile: [this.defaultMileValue, this.getNumbersValidatorsArray()],
            ferryMile: [this.defaultMileValue, this.getNumbersValidatorsArray()],
            trainInterval: [this.defaultIntervalValue, [Validators.required]],
            busInterval: [this.defaultIntervalValue, [Validators.required]],
            taxiInterval: [this.defaultIntervalValue, [Validators.required]],
            ferryInterval: [this.defaultIntervalValue, [Validators.required]]
        });
    }

    private next() {
        let calculatorName = Constants.calculators.individual;
        let categoryName = 'publicTransit';
        let params = {
            trainMile: this.getFV('trainMile'),
            busMile: this.getFV('busMile'),
            taxiMile: this.getFV('taxiMile'),
            ferryMile: this.getFV('ferryMile'),
            trainInterval: this.getFV('trainInterval'),
            busInterval: this.getFV('busInterval'),
            taxiInterval: this.getFV('taxiInterval'),
            ferryInterval: this.getFV('ferryInterval'),
        };

        if (!!+params.trainMile || !!+params.busMile || !!+params.taxiMile || !!+params.ferryMile) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];
                    this.emissionService.setEmission({
                        category: Constants.categories.individual.transit,
                        emission: {
                            emission: input.emmission,
                            emissionTrees: input.emissionTrees,
                            DollarAmt: input.DollarAmt,
                            DollarAmtMonthly: input.DollarAmtMonthly
                        }
                    });

                    this.footerService.skip();
                    this.spinner.hide();
                }
            );
        } else {
            this.emissionService.setEmission({
                category: Constants.categories.individual.transit,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });

            this.footerService.skip();
        }
    }

    private getNumbersValidatorsArray() {
        return [Validators.required, CustomValidators.min(0), CustomValidators.max(99999), CustomValidators.digits];
    }

    checkError(param) {
        return this.transitForm.get(param).status === 'INVALID' && (this.isFormSubmited || this.transitForm.get(param).touched);
    }

    getFV(param) {
        return this.transitForm.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/transit/transit.component.ts